import { useState, useEffect } from "react";

interface AutoFadeBeforeAfterProps {
  before: string;
  after: string;
  beforeAlt: string;
  afterAlt: string;
}

const AutoFadeBeforeAfter = ({ before, after, beforeAlt, afterAlt }: AutoFadeBeforeAfterProps) => {
  const [showAfter, setShowAfter] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowAfter(prev => !prev);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-full">
      {/* Before Image - base layer */}
      <img
        src={before}
        alt={beforeAlt}
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      
      {/* After Image - fades in/out */}
      <img
        src={after}
        alt={afterAlt}
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out ${
          showAfter ? 'opacity-100' : 'opacity-0'
        }`}
        loading="lazy"
      />
      
      {/* Dynamic Badge */}
      <div className="absolute top-3 left-3 z-10">
        <span 
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full font-semibold text-sm shadow-lg backdrop-blur-sm transition-all duration-500 ${
            showAfter 
              ? 'bg-gradient-to-r from-primary via-primary/90 to-accent text-primary-foreground' 
              : 'bg-gradient-to-r from-muted/95 to-muted/90 text-foreground border border-border/50'
          }`}
        >
          {showAfter ? '✨ After' : '😢 Before'}
        </span>
      </div>
    </div>
  );
};

export default AutoFadeBeforeAfter;
